export const categoriasPorcentajeEvaluacionDes = [
  {
    id: 0,
    label: 'Seleccionar Categoría',
    calificacionDesde: 0,
    calificacionHasta: 0,
  },
  {
    id: 1,
    label: 'Insatisfactorio (0-64)',
    calificacionDesde: 0,
    calificacionHasta: 64,
  },
  {
    id: 2,
    label: 'Bajo el promedio (65-74)',
    calificacionDesde: 65,
    calificacionHasta: 74,
  },
  {
    id: 3,
    label: 'Promedio (75-84)',
    calificacionDesde: 75,
    calificacionHasta: 84,
  },
  {
    id: 5,
    label: 'Superior al promedio (85-94)',
    calificacionDesde: 85,
    calificacionHasta: 94,
  },
  {
    id: 6,
    label: 'Sobresaliente (95-100)',
    calificacionDesde: 95,
    calificacionHasta: 100,
  },
];
